<template>
   <div style="min-height: calc(100% - 20px)" class="mobile-utilities mobile-utilities--3column">
      <!--<div class="mobile-utilities__top">
         <h4 class="mobile-utilities__sub">
            {{ $t('home.main_functions') }}
         </h4> 
      </div>-->
      <template v-if="!activeFTTH">
         <div class="mobile-utilities__actions">
            <div class="mobile-utilities__actions__item" @click="redirectTo('/mobile/customize-function')">
               <span>{{ $t('customize_func.sort') }} </span>
               <img :src="IconSort" alt="sort" />
            </div>
            <div class="mobile-utilities__actions__item" @click="toggle">
               <img :src="IconGift" alt="sort" />
            </div>
            <div class="mobile-utilities__actions__item" @click="redirectTo('/mobile/home')">
               <span>{{ $t('customize_func.view_all') }} </span>
               <i class="icon-fonts icon-fonts--chevron-right"></i>
            </div>
         </div>
         <hr class="mobile-utilities__divided" />
      </template>
      <div class="mobile-utilities__list__wrapper">
         <div class="mobile-utilities__list">
            <span
               v-if="isHavePrevPage"
               class="mobile-utilities__prev nav-home__ic text-primary fw-bold"
               @click="changePage('prev')"
            >
               <i class="icon-fonts icon-fonts--arrow-left"></i>
            </span>
            <span
               v-if="isHaveNextPage"
               class="mobile-utilities__next nav-home__ic text-primary fw-bold"
               @click="changePage('next')"
            >
               <i class="icon-fonts icon-fonts--arrow-right"></i>
            </span>
            <template v-if="activeFTTH || isLoggedIn">
               <div v-for="favourite in getFTTHList" :key="favourite.name" class="mobile-utilities__item">
                  <a class="mobile-utilities__link">
                     <span class="mobile-utilities__icon" @click="$emit('redirectToMobileFunc', favourite)">
                        <img :src="favourite.icon" alt="img" />
                     </span>
                     <h5 class="mobile-utilities__name" @click="$emit('redirectToMobileFunc', favourite)">
                        {{ favourite.name }}
                     </h5>
                  </a>
               </div>
            </template>
            <template v-else>
               <div v-for="favourite in getFavoriteList" :key="favourite.name" class="mobile-utilities__item">
                  <a v-if="favourite.openViewModal" class="mobile-utilities__link pointer" @click.prevent="handleRate">
                     <span class="mobile-utilities__icon">
                        <img :src="favourite.icon" alt="img" />
                     </span>
                     <h5 class="mobile-utilities__name">
                        {{ favourite.name }}
                     </h5>
                  </a>

                  <a v-else class="mobile-utilities__link">
                     <span class="mobile-utilities__icon" @click="$emit('redirectToMobileFunc', favourite)">
                        <img :src="favourite.icon" alt="img" />
                     </span>
                     <h5 class="mobile-utilities__name" @click="$emit('redirectToMobileFunc', favourite)">
                        {{ favourite.name }}
                     </h5>
                  </a>
               </div>
            </template>
         </div>

         <RateModal v-if="visibleRate" />
      </div>
      <!-- <div class="buy-online">
         <hr class="line" />
         <h4 class="buy-online__sub">{{ $t('home.buy_online.title') }}</h4>
         <ul class="buy-online__list">
            <li class="buy-online__item">
               <router-link class="buy-online__link" to="/shop-unitel/buy-sim">
                  <div class="buy-online__images">
                     <img alt="img" src="@/assets/images/img-buy-online-1.svg" />
                  </div>
                  <h5 class="buy-online__name">{{ $t('home.buy_online.simcard') }}</h5>
               </router-link>
            </li>
            <li class="buy-online__item">
               <router-link class="buy-online__link" to="/shop-unitel/buy-ftth">
                  <div class="buy-online__images">
                     <img alt="img" src="@/assets/images/img-buy-online-2.svg" />
                  </div>
                  <h5 class="buy-online__name">{{ $t('home.buy_online.ftth') }}</h5>
               </router-link>
            </li>
            <li class="buy-online__item">
               <router-link class="buy-online__link" to="/shop-unitel/buy-device">
                  <div class="buy-online__images">
                     <img alt="img" src="@/assets/images/img-buy-online-3.svg" />
                  </div>
                  <h5 class="buy-online__name">{{ $t('home.buy_online.devices') }}</h5>
               </router-link>
            </li>
         </ul>
      </div> -->
      <slot></slot>
   </div>
   <!--  <div v-if="!activeFTTH || isLinkedFTTH" class="mobile-utilities mobile-utilities--3column">
         <div class="mobile-utilities__top">
            <h4 class="mobile-utilities__sub">
               {{ $t('home.main_functions') }}
            </h4>
         </div>
         <ul class="mobile-utilities__list">
            <template v-if="activeFTTH">
               <li v-for="favourite in ftthList" :key="favourite.name" class="mobile-utilities__item">
                  <a class="mobile-utilities__link" @click="redirectToMobileFunc(favourite)">
                     <span class="mobile-utilities__icon"><img :src="favourite.icon" alt="img" /></span>
                     <h5 class="mobile-utilities__name">{{ favourite.name }}</h5>
                  </a>
               </li>
            </template>
            <template v-else>
               <li v-for="favourite in favouriteList" :key="favourite.name" class="mobile-utilities__item">
                  <a class="mobile-utilities__link" @click="redirectToMobileFunc(favourite)">
                     <span class="mobile-utilities__icon"><img :src="favourite.icon" alt="img" /></span>
                     <h5 class="mobile-utilities__name">{{ favourite.name }}</h5>
                  </a>
               </li>
            </template>
         </ul>
      </div>  -->
</template>

<script>
import IconGift from '@/assets/images/gift.svg'
import IconSort from '@/assets/images/ic_sort.svg'
import LocalStorage from '@/ultils/local-storage'
import RateModal from './RateModalSurvey.vue'
import $ from 'jquery'

export default {
   name: 'MainFunctions',
   components: {
      RateModal
   },
   props: {
      ftthList: {
         type: Array,
         default: () => []
      },
      favouriteList: {
         type: Array,
         default: () => []
      },
      isLoggedIn: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         page: 1,
         pageSize: 30,
         IconSort,
         IconGift,
         visibleRate: false,

      }
   },
   computed: {
      activeFTTH() {
         return this.$store.state.activeFTTH
      },

      getFavoriteList() {
         // return this.favouriteList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
         let listFeaturesSelected = JSON.parse(LocalStorage.getItem('features_' + LocalStorage.getItem('lang'))) || []
         const listFeatures = JSON.parse(LocalStorage.getItem('favourite_list_2204_' + LocalStorage.getItem('lang')))
         const newItems = listFeatures.filter(
            (feature) => listFeaturesSelected && !listFeaturesSelected.some((updated) => updated.url === feature.url)
         )
         listFeaturesSelected = [...listFeaturesSelected, ...newItems]

         if (listFeaturesSelected && listFeaturesSelected.length > 0) return listFeaturesSelected
         return this.favouriteList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
      },
      getFTTHList() {
         const result = this.ftthList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
         console.log('[DEBUG] getFTTHList:', result) // 👉 log ra dữ liệu
         return result
      },
      isHaveNextPage() {
         return this.activeFTTH
            ? this.ftthList.length > this.page * this.pageSize
            : this.favouriteList.length > this.page * this.pageSize
      },
      isHavePrevPage() {
         return this.page > 1
      }
   },
   watch: {
      activeFTTH() {
         this.page = 1
      }
   },

   methods: {

      toggle() {
         // const toggleEl = document.getElementById('toggleButton');

         // if (toggleEl) {
         // const input = toggleEl.querySelector('input[type="checkbox"]');
         // if (input) {
         //    input.click(); // trigger native click on checkbox
         // }
         // }

         // Redirect to the specified route
         this.$router.push('/ucare/customer-service/home');
      },

      handleRate(item) {
         this.visibleRate = true
         console.log('item', $)

         setTimeout(() => {
            let modal = new bootstrap.Modal(document.getElementById('review'))
            modal.show()
         }, 1)
      },

      changePage(type) {
         this.page = type === 'next' ? this.page + 1 : this.page - 1
      },
      redirectTo(path) {
         this.$router.push(path)
      }
   },
   emits: ['redirectToMobileFunc']
}
</script>

<style lang="scss" scoped>
.pointer {
   cursor: pointer;
}

.mobile-utilities {
   border: none;
   padding: 20px 0 0;
   margin: 20px 0 0;
   border-radius: 30px 30px 0 0;

   .buy-online {
      .line {
         margin: 25px 0;
      }

      padding: 0 20px;
      text-align: center;

      &__sub {
         margin: 0 0 25px;
         font-size: 17px;
      }
   }

   &__top {
      width: 200px;
      height: 40px;
      background-size: contain;
      top: -10px;
   }

   &__sub {
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      text-align: center;
      color: #fff;
      text-transform: capitalize;
   }

   &__list__wrapper {
      // min-height: calc( 100dvh - 291.5px );
      // overflow-y: scroll;
   }

   &__list {
      width: 100%;
      padding: 0 20px 20px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, 1fr);
      // margin: 36px 0 0;
      gap: 20px 0;
      position: relative;
   }

   &__item {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
   }

   &__link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
   }

   &__icon {
      width: 68px;
      height: 68px;
      gap: 0;
      border-radius: 20px;
      padding: 4px;
      margin: 0;
      background: #fff4ee;

      img {
         width: 100%;
         height: 100%;
         max-width: 32px;
         max-height: 32px;
         object-fit: contain;
      }
   }

   &__name {
      font-size: 13px;
      font-weight: 400;
      line-height: 16px;
      text-align: center;
      margin-top: 10px;
   }

   &__prev,
   &__next {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      background: #fff4ee;
      padding: 8px 4px;
      margin: 0;

      i {
         font-weight: 900;
      }
   }

   &__prev {
      left: 0;
      border-radius: 0 8px 8px 0;
   }

   &__next {
      right: 0;
      border-radius: 8px 0 0 8px;
   }

   &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      color: var(--bs-primary);

      &__item {
         cursor: pointer;
         font-weight: 600;
         font-size: 15px;
         color: var(--bs-primary);
         display: flex;
         justify-content: center;
         align-items: center;

         span {
            margin-right: 6px;
         }

         i {
            font-size: 10px;
         }
      }
   }

   &__divided {
      color: var(--bs-light-gray);
      margin: 10px 20px 30px;
   }
}
</style>
